export default __webpack_public_path__ + "static/media/Etherfishing_Adventure_Theme.db9b1427.wav";